import React, { useEffect, useState } from 'react'
import { Table, Spin, Empty, Button, message, Space } from 'antd'
import { DownloadOutlined, EyeOutlined } from '@ant-design/icons'
import { getStudentCertificates } from '../../../../../Constants/Api/functions/function'

const UserCertificates = ({ user }) => {
    const [certificates, setCertificates] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        if (user?.id) {
            const fetchUserCertificates = async () => {
                setIsLoading(true)
                try {
                    const data = await getStudentCertificates(user.id)
                    if (Array.isArray(data)) {
                        setCertificates(data)
                    } else {
                        setCertificates([])
                    }
                } catch (error) {
                    console.error('Error fetching certificates:', error)
                    message.error('Failed to fetch certificates')
                    setCertificates([])
                } finally {
                    setIsLoading(false)
                }
            }
            fetchUserCertificates()
        }
    }, [user?.id])

    const handleDownload = (certificateUrl) => {
        if (certificateUrl) {
            window.open(certificateUrl, '_blank')
            message.success('Opening certificate...')
        } else {
            message.warning('Certificate URL not available')
        }
    }

    const columns = [
        {
            title: 'Certificate Number',
            dataIndex: 'CertificateNumber',
            key: 'CertificateNumber',
            render: (text) => text || 'N/A',
        },
        {
            title: 'Course',
            dataIndex: 'CourseName',
            key: 'CourseName',
            render: (text) => text || 'N/A',
        },
        {
            title: 'Issue Date',
            dataIndex: 'IssueDate',
            key: 'IssueDate',
            render: (text) => text || 'N/A',
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Space>
                    <Button
                        type='primary'
                        size='small'
                        icon={<EyeOutlined />}
                        onClick={() => handleDownload(record.CertificateURL)}
                    >
                        View
                    </Button>
                    {record.CertificateURL && (
                        <a
                            href={record.CertificateURL}
                            download
                            target='_blank'
                            rel='noopener noreferrer'
                        >
                            <Button
                                size='small'
                                icon={<DownloadOutlined />}
                            >
                                Download
                            </Button>
                        </a>
                    )}
                </Space>
            ),
        },
    ]

    return (
        <div style={{ padding: '20px' }}>
            <Spin spinning={isLoading} tip='Loading certificates...'>
                {certificates && certificates.length > 0 ? (
                    <Table
                        columns={columns}
                        dataSource={certificates.map((cert, index) => ({
                            ...cert,
                            key: cert.CertificateID || index,
                        }))}
                        pagination={{ pageSize: 10 }}
                        scroll={{ x: 600 }}
                    />
                ) : (
                    <Empty
                        description='No certificates found'
                        style={{ marginTop: '50px' }}
                    />
                )}
            </Spin>
        </div>
    )
}

export default UserCertificates
